import "./Orders.css";
import { useTranslation } from "react-i18next";

const ConfirmationPopup = ({ setConfirmedPopupIsOpen, handleAction, status, isSubmitting }) => {
  const { t } = useTranslation("orders");

  const handleCancel = () => {
    setConfirmedPopupIsOpen(false);
  };

  return (
    <div className="confirmation-popup">
      <div className="confirmation-popup-content">
        <div className="flex justify-between items-center mb-[40px]">
          <h4 className="confirmation-heading">{t("confirmationPopup.title")}</h4>
          <button className="close-btn" onClick={handleCancel}>
            <img src="/x.svg" alt={t("confirmationPopup.closeAlt")} />
          </button>
        </div>
        <h5 className="confirmation-subheading">
          {t("confirmationPopup.question")}
        </h5>
        <p className="confirmation-desc">
          {t("confirmationPopup.description")}
        </p>
        <div className="action-btns">
          <button className="confirmation-cancel" onClick={handleCancel}>
            {t("confirmationPopup.cancel")}
          </button>
          <button
            className="confirmation-confirm"
            onClick={() => handleAction(status)}
            disabled={isSubmitting}
          >
            {isSubmitting ? t("confirmationPopup.confirming") :   t("confirmationPopup.confirm")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;